/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { NgOptimizedImage } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { DataFormService } from '@reports/services/data-form.service';
import { DownloadService } from '@shared/services/download.service';
import { StorageService } from '@shared/services/storage.service';
import { FileDeleteConfirmComponent } from './file-delete-confirm.component';
import { FileDownloadComponent } from './file-download.component';

@NgModule({
    imports: [ NgOptimizedImage, FileDownloadComponent, FileDeleteConfirmComponent ],
    providers: [ StorageService, DownloadService, DataFormService ]
})
export class FileDownloadModule {
    constructor(private injector: Injector) {
        const el = createCustomElement(FileDownloadComponent, {
            injector: this.injector
        });
        customElements.define('dash-gis-file-download', el);
    }
}
